import * as React from 'react';

export default class Backdrop extends React.Component<{ zIndex?: number }> {
  render() {
    return (
      <div
        className="section modal show fullscreen"
        style={{ display: 'block', zIndex: this.props.zIndex }}>
        <div className="modal-wrapper">
          <div className="background-overlay"></div>
          <div className="modal-container">{this.props.children}</div>
        </div>
      </div>
    );
  }
}
